module.exports = __webpack_public_path__ + "img/levy-bg-2.6f87011e.png";